import { render, staticRenderFns } from "./Create-Customer.vue?vue&type=template&id=749ee3a7&scoped=true"
import script from "./Create-Customer.vue?vue&type=script&lang=js"
export * from "./Create-Customer.vue?vue&type=script&lang=js"
import style0 from "./Create-Customer.vue?vue&type=style&index=0&id=749ee3a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ee3a7",
  null
  
)

export default component.exports